import { gql } from 'apollo-boost';

const manyQuery = gql`
  query groups($inputFilter: GroupFilterInputType) {
    groups(inputFilter: $inputFilter) {
      id
      trainerId
      name
      section
      status
      gymId
      gym {
        name
      }
      sectionObj {
        name
      }
      trainer {
        id
        fullName
        fullInitials
      }
      countAthletes
    }
  }
`;

const oneQuery = gql`
  query group($id: Int!) {
    group(id: $id) {
      id
      trainerId
      name
      section
      status
      gymId
      gym {
        name
      }
      sectionObj {
        name
      }
      schedule {
        dayNum
        selected
        gymId
        startAt
        endAt
      }
      athletes {
        id
        fullName
        birthday
        athleteStatus
      }
    }
  }
`;

const paginatedGroupsQuery = gql`
  query paginatedGroups($inputFilter: GroupFilterInputType) {
    paginatedGroups(inputFilter: $inputFilter) {
      items {
        id
        trainerId
        name
        section
        status
        gymId
        gym {
          name
        }
        sectionObj {
          name
        }
        trainer {
          id
          fullName
        }
        countAthletes
      }
      pageInfo {
        page
        pages
        total
      }
    }
  }
`;

export const createMutation = gql`
  mutation createGroup($inputData: GroupInputType!) {
    createGroup(inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const updateMutation = gql`
  mutation updateGroup($id: Int!, $inputData: GroupInputType!) {
    updateGroup(id: $id, inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const deleteMutation = gql`
  mutation deleteGroup($id: Int!) {
    deleteGroup(id: $id) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

const GROUPS = {
  manyQuery,
  oneQuery,
  paginatedGroupsQuery,
  createMutation,
  updateMutation,
  deleteMutation,
};

export default GROUPS;
